module.exports = __webpack_public_path__ + "static/media/book.2f01d77c.png";